import React, { useRef, useState } from 'react';
import { Text, Button, Loading, TagPreview, MediaDialog } from 'ui';
import { useAuth, updateTag, useTag, upload, useMedia, refreshTagPreview } from 'api';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import { tagTemplates } from 'config/tags';
import { darkBlue } from 'config/colors';
import "./index.css";
import uploadPlaceholder from './assets/upload-placeholder.jpg';

export default function TagUpload(props) {
  
  const uploaderRef = useRef();
  const [uploading, setUploading] = useState(false);
  
  
  // Dialog control.
  
  const [ isDialogOpen, setDialogOpen ] = useState(false);
  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);
  
  
  // Load the tag and media
  
  const auth = useAuth();
  const history = useHistory();
  const companyId = auth ? auth.company.id : null;
  const {tagId} = useParams();
  const tag = useTag(companyId, tagId);
  const [mediaUrl, setMediaUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const media = useMedia(auth ? auth.company.id : null);
  
  if(!tag) {
    return <Loading/>;
  }
  
  if(!tag.variant) {
    return <Redirect to="product"/>;
  }
  
  
  // Upload Image
   
  async function save() {
    if(mediaUrl) {
      const tpl = {logo:"", message:"", fontSize:24, background:`center / cover url(${mediaUrl})`};
      const html = tagTemplates[tag.variant.id](tpl);
      await updateTag(companyId, tagId, {html, tpl});
    }
    
    if(file) {
      if(uploading) {
        return;
      }
      setUploading(true);
      try {
        const url = await upload(companyId, file);
        const tpl = {logo:"", message:"", fontSize:24, background:`center / cover url(${url})`};
        const html = tagTemplates[tag.variant.id](tpl);
        await updateTag(companyId, tagId, {html, tpl});
      } catch(error) {
        console.error(error);
        setUploading(false);
        return;
      }
    }
    
    refreshTagPreview(companyId, tagId);
    
    history.push(tag.campaignId !== "NONE" ? `/campaigns/${tag.campaignId}` : '/tags');
  }
  
  async function handleUploaderChange(e) {
    if (FileReader && e.target.files.length) {
      setFile(e.target.files[0]);
      var fr = new FileReader();
      fr.onload = function () {
        setFilePreview(fr.result);
      };
      fr.readAsDataURL(e.target.files[0]);
    }
  }
  
  
  async function changeType(type="design") {
    await updateTag(companyId, tagId, {type});
    history.push('edit');
  }
  
  
  // Render
  
  return (
    <div className="tagupload-wrapper">
      <div className="tagupload-left">
        
        <div className="tagupload-left-header">
          <Text block style={{flex:1}} bold large color={darkBlue}>{tag.name || tag.variant.title}</Text>
          <Button onClick={() => changeType('design')} backgroundColor="#f76480">
            <svg width="24" height="24" viewBox="0 0 24 24" style={{fill:'white', marginRight:8}}>
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
            </svg>
            <Text white>User our design tools</Text>
          </Button>
        </div>
        
        <div className="tagupload-left-body">
          
          <Button onClick={openDialog} className={`tagupload-tag`} style={{opacity:1}}>
            {uploading ? (
              <Loading style={{color:'white', height:64}}/>
            ) : (
              <TagPreview 
                {...tag} 
                style={{boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px"}} 
                preview={(filePreview || mediaUrl) ? null : tag.preview}
                placeholder={filePreview || mediaUrl || uploadPlaceholder}
              />
            )}
          </Button>
          
        </div>
        
      </div>
      <div className="tagupload-right">
        <div>
          <Text block>Artwork Suggestions</Text>
          <br/>
          <Text block small bold>Text</Text>
          <Text block small>Keep all text 7pt or higher</Text>
          <br/>
          <Text block small bold>Lines</Text>
          <Text block small>Sharp lines need to be at 0.5pt or thicker.</Text>
          <br/>
          <Text block small bold>Resolution</Text>
          <Text block small>Image should be 450 pixels in width and height (300dpi).</Text>
          <br/>
          <Text block small bold>Cropmarks</Text>
          <Text block small>No need. We add them automatically in exactly the right place.</Text>
          <br/>
          {(tag.preview || filePreview || mediaUrl) && (
            <Button onClick={openDialog} backgroundColor="#f76480" white label="Change Image"/>
          )}
        </div>
        <div className="tagupload-save">
          <Button label="SAVE & CLOSE" small white onClick={save}/>
        </div>
      </div>
      
      <MediaDialog 
        open={isDialogOpen} 
        onRequestClose={closeDialog} 
        media={media}
        onUpload={() => {
          uploaderRef.current.click();
          closeDialog();
        }}
        onSelect={url => {
          setMediaUrl(url);
          setFile(null);
          closeDialog();
        }}
      />
      <input key={tag.id} type="file" onChange={handleUploaderChange} style={{display:'none'}} ref={uploaderRef}/>
    </div>
  );
}